import React, { useEffect, useRef } from "react";
import { motion, useInView, useAnimation } from "framer-motion";

const Reveal = ({ width, children, head, height, className, grid }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true });

  const mainControls = useAnimation();
  const slideControls = useAnimation();

  useEffect(() => {
    if (inView) {
      mainControls.start("visible");
      slideControls.start("visible");
    }
  }, [inView]);

  return (
    <div
      className={className}
      ref={ref}
      style={{
        position: "relative",
        width: width,
        height: height && "100%",
      }}
    >
      <motion.div
        variants={{
          hidden: { opacity: 0, y: head ? -75 : 75 },
          visible: { opacity: 1, y: 0 },
        }}
        style={{
          height: height && "100%",
        }}
        initial="hidden"
        className={grid ? "grid h-full" : ""}
        animate={mainControls}
        transition={{ duration: 0.8, delay: 0.8 }}
      >
        {children}
      </motion.div>
    </div>
  );
};

export default Reveal;
